import React from 'react';
import { FormErrorMessage } from "../error/form-error-message";
export const RhfFieldError = props => {
  const {
    errorMessage,
    error
  } = props;
  const show = React.useMemo(() => Boolean(errorMessage) && Boolean(error), [errorMessage, error]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormErrorMessage, {
    show: show
  }, errorMessage && error ? /*#__PURE__*/React.createElement(React.Fragment, null, typeof errorMessage === 'function' ? errorMessage(error) : errorMessage) : /*#__PURE__*/React.createElement(React.Fragment, null, error === null || error === void 0 ? void 0 : error.message)));
};